import React from "react";
import { Alert } from '@sainsburys-tech/fable';
import { Clock } from '@sainsburys-tech/icons'

const ManagersOverridePendingBanner = props => (
  <div className="fable:pb-4 fable:pt-4">
    <Alert 
      status="info" 
      isOpen={true} 
      key={"managersOverridePending"}
      leadingIcon={<Clock />}
    >
      {props.children}
    </Alert>
  </div>
);

export default ManagersOverridePendingBanner;
